import LTR from "@brand-icons/ploomg4/device-bluetooth/device-bluetooth-ltr.svg";
import RTL from "@brand-icons/ploomg4/device-bluetooth/device-bluetooth-rtl.svg";

import { iconFactory } from "../iconFactory";

export const DeviceBluetoothIcon = iconFactory("DeviceBluetoothIcon", LTR, RTL);
